import { render } from "./CompanyMatchesPanel.vue?vue&type=template&id=b46557c6&scoped=true"
import script from "./CompanyMatchesPanel.vue?vue&type=script&lang=js"
export * from "./CompanyMatchesPanel.vue?vue&type=script&lang=js"

import "./CompanyMatchesPanel.vue?vue&type=style&index=0&id=b46557c6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b46557c6"]])

export default __exports__